/**
 * Dashboard Store
 *
 * Zustand store for managing portfolio dashboard filter state
 */

import { create } from 'zustand';

interface DashboardState {
  // Filter state
  selectedPortfolioId: string | undefined;
  selectedStatus: string | undefined;
  searchQuery: string;
  currentPage: number;

  // Actions
  setPortfolioFilter: (portfolioId: string | undefined) => void;
  setStatusFilter: (status: string | undefined) => void;
  setSearchQuery: (query: string) => void;
  setPage: (page: number) => void;
  resetFilters: () => void;
}

export const useDashboardStore = create<DashboardState>((set) => ({
  // Initial state
  selectedPortfolioId: undefined,
  selectedStatus: undefined,
  searchQuery: '',
  currentPage: 1,

  // Actions
  setPortfolioFilter: (portfolioId) =>
    set({ selectedPortfolioId: portfolioId, currentPage: 1 }),

  setStatusFilter: (status) =>
    set({ selectedStatus: status, currentPage: 1 }),

  setSearchQuery: (query) =>
    set({ searchQuery: query, currentPage: 1 }),

  setPage: (page) =>
    set({ currentPage: page }),

  resetFilters: () =>
    set({
      selectedPortfolioId: undefined,
      selectedStatus: undefined,
      searchQuery: '',
      currentPage: 1,
    }),
}));
